/**
 * @since 1.0.0
 */
export const hasBody = method => method !== "GET" && method !== "HEAD";
//# sourceMappingURL=HttpMethod.js.map